import { AxiosError, AxiosInstance } from 'axios';

import store from 'store/store';

import { VaultService } from './storage';

const storage = new VaultService();

export const setRequestInterceptorWithToken = (instance: AxiosInstance) => {
	instance.interceptors.request.use(
		(req) => {
			const TOKEN = storage.getItem('token');

			req.signal = store.getState().userRedux.cancelToken.signal;

			if (TOKEN && req.headers) {
				Object.assign(req.headers, { Authorization: `bearer ${TOKEN}` });
			}

			if (!TOKEN) {
				delete instance.defaults.headers.common.Authorization;
			}

			return req;
		},
		(error: AxiosError) => {
			return Promise.reject(error.response);
		}
	);
};
